import Vue from 'vue'
import Router from 'vue-router'

import { isMobile, isWeixin } from '../module/tools';
import web from './web'; // PC端相关路由
import wap from './wap'; // 移动端相关路由
const _vm = new Vue()

Vue.use(Router);

 const router = new Router({
  mode: 'history',
  // base: '/saas/', // base功能统一不使用base
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {x: 0, y: 0}
  },
  routes: [
    { path: '/', redirect: () => {
      if (isMobile()) {
        return { name: 'wapIndex'};
      } else {
        return { name: 'index' };
      }
    }},
    ...web,
    ...wap
  ]
})
router.afterEach((to, from) => {
  if (isWeixin()) {
    _vm.$wxReady(_vm)
  }
})

export default router
